import React from "react";
import GoogleMaps from "../../components/google-maps/google-maps";
import ContactCard from "../../components/details-contact-page/details-contact-page";
// import FormContact from "../../components/form-contact/formcontact";
import FormContact2222222 from "../../components/form-contact/formcontact";

const Contact = () => {
  return (
    <>
      <FormContact2222222 />
      <GoogleMaps />
      <ContactCard />
    </>
  );
};

export default Contact;
